import { Button, Flex, Heading, Text } from "@chakra-ui/react";
import React, { FunctionComponent, ReactElement } from "react";
import { useNavigate } from "react-router-dom";

// Components
import { MainPageCard } from "../../shared/layout/index.styles";

// Images
import logo from "../../assets/images/logo.png";

interface AccessDeniedPageProps {
	navigateTo?: string;
	buttonText?: string;
}

const AccessDeniedPage: FunctionComponent<AccessDeniedPageProps> = ({
	navigateTo = "/",
	buttonText = "Return Home"
}): ReactElement => {
	const navigate = useNavigate();

	return (
		<Flex flexDirection={"column"} justifyContent="center" alignItems={"center"} p={7} w="100%">
			<img src={logo} alt={"logo"} />
			<MainPageCard mt={6}>
				<Heading mb={"5"} textAlign="center" color="secondary">
					Access Denied
				</Heading>
				<Text textAlign="center" color="gray.600" fontSize="lg">
					You do not have permission to access this page.
				</Text>
				<Flex flexDirection={"column"} alignItems="center" mt={5}>
					<Button colorScheme="orange" minW={200} onClick={() => navigate(navigateTo)}>
						{buttonText}
					</Button>
				</Flex>
			</MainPageCard>
		</Flex>
	);
};

export default AccessDeniedPage;
